// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/data/user_avatar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overall container uses position: relative so fixed children can overlay properly */
.app-container {
  position: relative;
  height: 100vh;
  background-color: #343541;
  margin: 0;
  padding: 0;
  overflow: hidden;
  /* font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif; */
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, "Poppins", sans-serif;
}

/* Top Navbar fixed at top */
.top-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px; /* Adjust if needed */
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--bg-header-sidebar);
  color: var(--color-sidebar);
  padding: 0.5rem 1rem;
  z-index: 2000;
}

.navbar-left {
  display: flex;
  align-items: center;
}

.navbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;
}

.hamburger-btn {
  font-size: 24px;
  background: none;
  border: none;
  color: var(--color-hamburger);
  cursor: pointer;
}
.navbar-title {
  margin-left: 1rem;
  font-size: 18px;
  font-weight: 800;
  height: 100%;
  transform: translateY(3px);
  filter: invert();
}

/* Sidebar fixed below navbar */
.sidebar-wrapper {
  position: fixed;
  top: 48px; /* Below navbar */
  left: 0;
  width: 260px;
  height: calc(100vh - 48px);
  background-color: #202123;
  z-index: 1500;
  overflow-y: auto;
  transition: transform 0.3s ease;
}

/* Desktop: sidebar always visible */
@media screen and (min-width: 768px) {
  .sidebar-wrapper {
    transform: translateX(0);
  }
}

/* Mobile: hidden by default */
@media screen and (max-width: 767px) {
  .sidebar-wrapper {
    transform: translateX(-100%);
  }
  .sidebar-wrapper.open {
    transform: translateX(0);
  }
}

/* Overlay for mobile */
.sidebar-overlay {
  position: fixed;
  top: 48px;
  left: 0;
  width: 100vw;
  height: calc(100vh - 48px);
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1400;
}

/* Chat area: pinned below navbar, offset to the right of sidebar on desktop */
.chat-area-wrapper {
  position: absolute;
  top: 48px; /* same as navbar */
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  overflow: hidden;
}

/* On desktop, offset chat area by 260px so it doesn't overlap sidebar */
@media screen and (min-width: 768px) {
  .chat-area-wrapper {
    margin-left: 260px;
  }
}

.u-user-info {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  cursor: pointer;
  /* Default background image will be used only if no initials are shown */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  font-size: 1.1rem;
  color:blue; /* This is now the default text color if initials are shown */
}

.u-user-info .user-initials {
  background-color: #fff; /* White background for initials */
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: blue; /* Blue text for initials */
}

.popover {
  position: absolute;
  top: 100%;
  right: 0;
  width: 250px;
  background-color: var(--bg-popover);
  border: 1px solid var(--color-border-popover);
  margin-right: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0,15);
  overflow: hidden;
  z-index: 100;
}

.popover-header {
  padding: 10px;
  font-weight: bold;
  text-align: center;
}

.popover-content {
  display: flex;
  padding: 5px 20px;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  pointer-events: auto;
}

.popover-content:hover {
  background-color: var(--bg-hover-popover);
}

.popover-content-icon {
  font-size: 10px;
}

.confirmation-popover {
  position: absolute;
  top: 100%;
  right: 0;
  width: 250px;
  background-color: var(--bg-popover);
  border: 1px solid var(--color-border-popover);
  margin-right: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0,15);
  overflow: hidden;
  padding: 15px;
  z-index: 200;
}

.confirmation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.btn {
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.btn.confirm {
  background-color: tomato;
  color: white;
  border: none;
}

.btn.cancel {
  background-color: var(--bg-popover);
  color: var(--color-sidebar);
  border: 1px solid var(--color-border-popover);
}

body.modal-open {
  overflow: hidden;
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA,qFAAqF;AACrF;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kEAAkE;EAClE,0KAA0K;AAC5K;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY,EAAE,qBAAqB;EACnC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,SAAS,EAAE,iBAAiB;EAC5B,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,oCAAoC;AACpC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,oCAAoC;EACpC,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,SAAS,EAAE,mBAAmB;EAC9B,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,wEAAwE;EACxE,2EAAuE;EACvE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU,EAAE,6DAA6D;AAC3E;;AAEA;EACE,sBAAsB,EAAE,kCAAkC;EAC1D,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW,EAAE,2BAA2B;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,mCAAmC;EACnC,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,mCAAmC;EACnC,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n/* Overall container uses position: relative so fixed children can overlay properly */\n.app-container {\n  position: relative;\n  height: 100vh;\n  background-color: #343541;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  /* font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif; */\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, \"Poppins\", sans-serif;\n}\n\n/* Top Navbar fixed at top */\n.top-navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 48px; /* Adjust if needed */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--bg-header-sidebar);\n  color: var(--color-sidebar);\n  padding: 0.5rem 1rem;\n  z-index: 2000;\n}\n\n.navbar-left {\n  display: flex;\n  align-items: center;\n}\n\n.navbar-right {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 25px;\n}\n\n.hamburger-btn {\n  font-size: 24px;\n  background: none;\n  border: none;\n  color: var(--color-hamburger);\n  cursor: pointer;\n}\n.navbar-title {\n  margin-left: 1rem;\n  font-size: 18px;\n  font-weight: 800;\n  height: 100%;\n  transform: translateY(3px);\n  filter: invert();\n}\n\n/* Sidebar fixed below navbar */\n.sidebar-wrapper {\n  position: fixed;\n  top: 48px; /* Below navbar */\n  left: 0;\n  width: 260px;\n  height: calc(100vh - 48px);\n  background-color: #202123;\n  z-index: 1500;\n  overflow-y: auto;\n  transition: transform 0.3s ease;\n}\n\n/* Desktop: sidebar always visible */\n@media screen and (min-width: 768px) {\n  .sidebar-wrapper {\n    transform: translateX(0);\n  }\n}\n\n/* Mobile: hidden by default */\n@media screen and (max-width: 767px) {\n  .sidebar-wrapper {\n    transform: translateX(-100%);\n  }\n  .sidebar-wrapper.open {\n    transform: translateX(0);\n  }\n}\n\n/* Overlay for mobile */\n.sidebar-overlay {\n  position: fixed;\n  top: 48px;\n  left: 0;\n  width: 100vw;\n  height: calc(100vh - 48px);\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1400;\n}\n\n/* Chat area: pinned below navbar, offset to the right of sidebar on desktop */\n.chat-area-wrapper {\n  position: absolute;\n  top: 48px; /* same as navbar */\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  overflow: hidden;\n}\n\n/* On desktop, offset chat area by 260px so it doesn't overlap sidebar */\n@media screen and (min-width: 768px) {\n  .chat-area-wrapper {\n    margin-left: 260px;\n  }\n}\n\n.u-user-info {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  cursor: pointer;\n  /* Default background image will be used only if no initials are shown */\n  background: url('/public/data/user_avatar.png') no-repeat center center;\n  background-size: cover;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: normal;\n  font-size: 1.1rem;\n  color:blue; /* This is now the default text color if initials are shown */\n}\n\n.u-user-info .user-initials {\n  background-color: #fff; /* White background for initials */\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: blue; /* Blue text for initials */\n}\n\n.popover {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 250px;\n  background-color: var(--bg-popover);\n  border: 1px solid var(--color-border-popover);\n  margin-right: 10px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0,15);\n  overflow: hidden;\n  z-index: 100;\n}\n\n.popover-header {\n  padding: 10px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.popover-content {\n  display: flex;\n  padding: 5px 20px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.popover-content:hover {\n  background-color: var(--bg-hover-popover);\n}\n\n.popover-content-icon {\n  font-size: 10px;\n}\n\n.confirmation-popover {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 250px;\n  background-color: var(--bg-popover);\n  border: 1px solid var(--color-border-popover);\n  margin-right: 10px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0,15);\n  overflow: hidden;\n  padding: 15px;\n  z-index: 200;\n}\n\n.confirmation-buttons {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.btn {\n  padding: 5px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.btn.confirm {\n  background-color: tomato;\n  color: white;\n  border: none;\n}\n\n.btn.cancel {\n  background-color: var(--bg-popover);\n  color: var(--color-sidebar);\n  border: 1px solid var(--color-border-popover);\n}\n\nbody.modal-open {\n  overflow: hidden;\n  height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
